import React from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import NoDataFound from "../NoDataFound";
import { ShowLoader } from "../../common/ShowLoader";

const GiftTable = ({
  isRatingDataEmpty,
  ratingResult = [],
  styles,
  ratingDataEmpty,
  showLoader,
}) => {
  const deviceSize = useDeviceSize();

  return (
    <>
      <View
        style={{
          height: 32,
          gap: 25,
          flexDirection: "row",
          justifyContent: "space-between",
          backgroundColor: AppColors.grayColor_565656,
          borderRadius: 12,
          paddingHorizontal: 10,
          paddingVertical: 8,
          minHeight: 50,
          marginBottom: 20,
        }}
      >
        {[
          "Rank",
          "User Name",
          "Won Belts",
          "Total Views",
          "Gifts Received",
        ].map((item, index) => (
          <View
            key={index}
            style={{
              flex: 1,
              borderRadius: 12,
              justifyContent: "flex-start",
              alignItems: "center",
              flexDirection: "row",
              gap: 8,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                  ? AppFontStyle.BOLD_ANYBODY_14
                  : AppFontStyle.BOLD_ANYBODY_12,
                { color: AppColors.white },
              ]}
            >
              {item}
            </Text>
          </View>
        ))}
      </View>
      {isRatingDataEmpty ? (
        <NoDataFound />
      ) : (
        ratingResult.map((item, index) => (
          <View
            key={index}
            style={{
              height: 50,
              gap: 15,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor:
                index === 0
                  ? "rgba(109, 8, 195, 0.4)"
                  : "rgba(109, 8, 195, 0.2)",
              borderRadius: 12,
              paddingLeft: 8,
              paddingRight: 25,
              marginVertical: 5,
            }}
          >
            <View
              style={{
                borderRadius: 10,
                backgroundColor: AppColors.appViolentColor_6D08C3,
                width: 46,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: "white",
                  },
                ]}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                {item.rank}
              </Text>
            </View>

            <View style={{ width: 50 }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: "white",
                  },
                ]}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                {item.userId}
              </Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                gap: 5,
                alignItems: "center",
                width: 50,
              }}
            >
              <Image
                source={AppImages.icBronzeMedal}
                style={{
                  height: 14,
                  width: 10,
                  resizeMode: "contain",
                }}
              />
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                {item.beltsWon}
              </Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                gap: 5,
                alignItems: "center",
                width: 50,
              }}
            >
              <Image
                source={AppImages.icEye}
                style={{
                  height: 20,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}
              >
                {item.totalViews}
              </Text>
            </View>

            <View
              style={{
                flexDirection: "row",
                gap: 5,
                alignItems: "center",
                width: 50,
              }}
            >
              <Image
                source={AppImages.icGift}
                style={{
                  height: 20,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                {item.giftsReceived}
              </Text>
            </View>
          </View>
        ))
      )}
    </>
  );
};

export default GiftTable;
